// Este fichero es para instalar de manera global los métodos útiles

import Vue from "vue";

const utils = new Vue({
  // (se crea como componente Vue para que tenga acceso a toda la funcionalidad del framework,
  // p.e. $materialApp.utils, $log...)
  methods: {
    cloneObject(object) {
      var clonedObject = null;

      try {
        clonedObject = JSON.parse(JSON.stringify(object));
      } catch (e) {
        this.$mdApp.log.error("------- Error clonando objeto: ");
        this.$mdApp.log.error(JSON.stringify(object));
        this.$mdApp.log.error("Exception: ");
        this.$mdApp.log.error(e); // error in the above string (in this case, yes)!
        this.$mdApp.log.error("------- Fin error clonando objeto: ");
      }

      return clonedObject;
    },
    hasEqualsValues(object1, object2) {
      return JSON.stringify(object1) === JSON.stringify(object2);
    },
    /**
     * Devuelve una nueva url pero cambiando el recurso, útil para cuando se quiere hace run link a un recurso en la misma
     * página
     */
    getUriWithSamePathReplacingResource(oldUrl, newResource) {
      // Sustituye lo ultimo '/<resource>.xxxx' por el nbuevo recurso
      return oldUrl.replace(/\/(?=[^/]*$).+\..+/, `/${newResource}`);
    }
  }
});

export default utils;
